import React, {Component} from 'react';
import styles from './styles.css';

export default class TemplateVariable extends Component {
	render() {
		let nameClassName = styles['variable__name'];

		if (this.props.tiny)
		{
			nameClassName += ' ' + styles['variable__name_tiny'];
		}

		return (
			<p className={styles['variable']}>
				<span className={nameClassName} onClick={(e) => {
					if (window.getSelection) {
						window.getSelection().selectAllChildren(e.target);
					}
					else { // старый IE
						var range = document.selection.createRange();
						range.moveToElementText(e.target);
						range.select();
					}
				}}>{this.props.name}</span>{this.props.children ? " - " + this.props.children : null}
			</p>
		);
	}
}